export const api = "https://yasir.sinecure.xyz";
